import React, {Component} from 'react';
import PropTypes from "prop-types";

import LostPasswordOverlay from "./LostPasswordOverlay";

class LostPasswordButton extends Component {
  static propTypes = {
    onOpen: PropTypes.func,
    onClose: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      overlayVisible: false
    }
  }

  onLostPasswordToggle(e) {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      overlayVisible: !this.state.overlayVisible
    }, () => {
      if (this.state.overlayVisible && typeof this.props.onOpen === "function") {
        this.props.onOpen();
      }

      if (!this.state.overlayVisible && typeof this.props.onClose === "function") {
        this.props.onClose();
      }
    });

    return false;
  }

  render() {
    const { overlayVisible } = this.state;

    return (
      <React.Fragment>
        <button className={this.props.className || 'btn btn-primary btn-block'} onClick={this.onLostPasswordToggle.bind(this)}>{this.props.children || "Lost password?"}</button>
        <LostPasswordOverlay visible={overlayVisible} onClose={this.onLostPasswordToggle.bind(this)} />
      </React.Fragment>
    );
  }
}

export default LostPasswordButton;